const moment = require("moment-timezone");
moment.tz.setDefault("America/Tegucigalpa");

const daysRestriction = () => {
  const today = moment().format("YYYY-MM-DD");

  const restriction =
    today === "2021-02-12" || today === "2021-02-13" || today === "2021-02-14"
      ? true
      : false;

  return restriction;
};

export { daysRestriction };
